import { useEffect, useRef, useState } from "react";
import { useHookUserRole } from "../../../hooks/useHookUserRole";

export const SelectUserRole = ({
    label,
    value,
    setValue,
    placeholder = "Pilih Role",
    searchable = true,
}) => {
    const { data } = useHookUserRole();
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const wrapperRef = useRef(null);

    // Pastikan data adalah array agar tidak error saat .find atau .filter
    const safeData = Array.isArray(data) ? data : [];

    // Menutup dropdown jika klik di luar komponen
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Mencari item yang terpilih berdasarkan ID (sesuai data hook Anda)
    const selected = safeData.find((o) => o.id === value);

    // Filter data berdasarkan input search (aman dari undefined)
    const filteredOptions = safeData.filter((o) =>
        o?.name?.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="w-full relative" ref={wrapperRef}>
            {label && (
                <label className="text-sm font-medium text-gray-700 mb-1 block">
                    {label}
                </label>
            )}

            {/* Select Box */}
            <div
                onClick={() => setOpen(!open)}
                className="w-full flex items-center justify-between px-3 py-2 mt-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 uppercase" 
            >
                <span className={`text-ellipsis line-clamp-1 ${!selected ? "text-gray-400" : "text-gray-900"}`}>
                    {selected ? selected.name : placeholder}
                </span>
                {/* Icon panah sederhana */}
                <span className="text-gray-400 text-xs ">{open ? "▲" : "▼"}</span>
            </div>


            {/* Dropdown Menu */}
            {open && (
                <div className="absolute z-50 mt-1 w-full bg-white border rounded-lg shadow-lg overflow-hidden">
                    {/* Input Pencarian */}
                    {searchable && (
                        <div className="p-2 border-b bg-gray-50">
                            <input
                                type="text"
                                placeholder="Cari Role Pengguna..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                className="w-full px-3 py-1.5 border rounded-md outline-none text-sm focus:border-indigo-500"
                                autoFocus
                            />
                        </div>
                    )}

                    {/* List Options */}
                    <div className="max-h-60 overflow-y-auto">
                        <div
                            onClick={() => {
                                setValue("") // Mengirim ID ke parent
                                setOpen(false);
                                setSearch("");
                            }}
                            className={`px-3 py-2 cursor-pointer text-sm transition-colors uppercase
                                        ${value === "" ? 'bg-indigo-50 text-indigo-700 font-semibold' : 'text-gray-700 hover:bg-gray-100'}
                                    `}
                        >
                            <div className="flex justify-between items-center">
                                Pilih Role
                            </div>
                        </div>
                        {filteredOptions.length === 0 ? (
                            <div className="px-3 py-3 text-center text-gray-400 text-sm italic">
                                Data tidak ditemukan
                            </div>
                        ) : (
                            filteredOptions.map((opt) => (
                                <div
                                    key={opt.id}
                                    onClick={() => {
                                        setValue(opt.id) // Mengirim ID ke parent
                                        setOpen(false);
                                        setSearch("");
                                    }}
                                    className={`px-3 py-2 cursor-pointer text-sm transition-colors
                                        ${value === opt.id ? 'bg-indigo-50 text-indigo-700 font-semibold' : 'text-gray-700 hover:bg-gray-100'}
                                    `}
                                >
                                    <div className="flex justify-between items-center uppercase">
                                        {opt.name}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};